import { render, staticRenderFns } from "./user-avatar-dialog.vue?vue&type=template&id=7a6c252e&"
import script from "./user-avatar-dialog.vue?vue&type=script&lang=js&"
export * from "./user-avatar-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports